import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4),
    backgroundColor: '#7833FF',
    color: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[3],

    '& img': {
      marginTop: theme.spacing(-1),
    },

    '& h5': {
      margin: theme.spacing(0, 6),
    },

    [theme.breakpoints.down('md')]: {
      display: 'grid',
      alignItems: 'center',
      justifyItems: 'center',

      '& img': {
        height: 70,
      },

      '& a': {
        maxWidth: 150,
        marginTop: 15,
      },

      '& p': {
        fontSize: 35,
        lineHeight: '1.4',
        textAlign: 'center',
      },
    },
  },
  button: {
    padding: theme.spacing(1.3, 4),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    color: theme.palette.common.white,
    background: 'none',
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: '#7833FF',
    },
  },
  invite: {
    fontSize: '32px',
    margin: '0px 50px',
  },
}));
